import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { rememberPostLoginPath } from "./utils/postLoginPath";
import { SplashLayout } from "./components/splash/SplashLayout";
import { HomePage } from "./components/splash/HomePage";
import { FeaturesPage } from "./components/splash/FeaturesPage";
import { ContactPage } from "./components/splash/ContactPage";
import { Register } from "./pages/Register";
import { SuperAdminRegister } from "./pages/SuperAdminRegistration";
import { BusinessAdminRegister } from "./pages/BusinessAdminRegistration";
import { AccountStatus } from "./components/SubscriptionManagement";
import { Login } from "./pages/Login";

/** Saves an in-app URL opened while signed out, so sign-in can return there. */
const RememberSignedOutAppPath = () => {
    const location = useLocation();

    useEffect(() => {
        rememberPostLoginPath(location.pathname, location.search);
    }, [location.pathname, location.search]);

    return null;
};

export const LoggedOutRoutes = () => {
    return (
        <>
            <RememberSignedOutAppPath />
            <Routes>
            {/* Public marketing pages with shared nav/footer layout */}
            <Route element={<SplashLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/es" element={<HomePage />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/contact" element={<ContactPage />} />
            </Route>

            {/* Auth and registration routes (no shared layout) */}
            <Route path="/register/:userIdFromParams" element={<Register />} />
            <Route path="/register/admin/:userIdFromParams" element={<SuperAdminRegister />} />
            <Route path="/register/platform-admin/:userIdFromParams" element={<BusinessAdminRegister />} />
            <Route path="/account" element={<AccountStatus />} />
            <Route path="/login" element={<Login logIn={true} initialState="signIn" />} />
            <Route path="/signup" element={<Login logIn={false} initialState="signUp" />} />
            <Route path="/register/free-demo" element={<Login logIn={false} initialState="signUp" />} />

            {/* Fallback to home */}
            <Route path="*" element={<SplashLayout />}>
                <Route path="*" element={<HomePage />} />
            </Route>
            </Routes>
        </>
    );
}
